/**
 * header-extras.js
 * -----------------------------------------------------------------------------
 * Non-first-paint header behaviour, extracted from inline <script> blocks so it
 * ships as a cached asset (loaded with defer + fetchpriority="low") instead of
 * ~11KB of inline JS on every HTML document.
 *
 * Currently holds the toolbar announcement rotator + info-panel toggle (moved
 * out of snippets/toolbar.liquid). The logic reads NO Liquid values — every
 * announcement string is baked into the toolbar markup — so no inline config
 * bootstrap is required. First paint is unaffected: slide 0 is already
 * .is-active in the server-rendered HTML; rotation and the panel are purely
 * post-paint interactions.
 */
(function () {
  // Initialise one toolbar root. Idempotent via the toolbarInit flag, so a
  // stray double-call (or a section:load after the initial pass) is a no-op.
  function initToolbar(root) {
    if (!root || root.dataset.toolbarInit) return;
    root.dataset.toolbarInit = 'true';

    var button = root.querySelector('[data-toolbar-announcement]');
    var panel = root.querySelector('[data-toolbar-panel]');
    var slides = root.querySelectorAll('[data-ann-slide]');
    if (!button || !panel) return;
    var current = 0;
    var timer = null;

    function show(i) {
      slides.forEach(function (s, idx) {
        s.hidden = idx !== i;
        s.classList.toggle('is-active', idx === i);
      });
      current = i;
    }

    function startRotation() {
      stopRotation();
      if (document.hidden) return; // no ticking in background tabs
      timer = window.setInterval(function () {
        show((current + 1) % slides.length);
      }, 5000);
    }
    function stopRotation() { if (timer) { window.clearInterval(timer); timer = null; } }

    // Pause in hidden tabs (battery/CPU), resume on return.
    var onVisibility = function () {
      if (document.hidden) { stopRotation(); }
      else if (panel.hidden) { startRotation(); }
    };
    document.addEventListener('visibilitychange', onVisibility);

    // Theme editor re-renders the section: tear down the old instance's
    // interval + document listeners so they don't compound.
    document.addEventListener('shopify:section:unload', function (evt) {
      if (evt.target && evt.target.contains && evt.target.contains(root)) {
        stopRotation();
        document.removeEventListener('visibilitychange', onVisibility);
      }
    });

    function openPanel() {
      panel.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      stopRotation();
    }
    function closePanel() {
      panel.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      startRotation();
    }

    button.addEventListener('click', function () {
      panel.hidden ? openPanel() : closePanel();
    });
    document.addEventListener('click', function (evt) {
      if (!root.isConnected) return; // stale instance after section re-render
      if (!panel.hidden && !root.contains(evt.target)) closePanel();
    });
    document.addEventListener('keyup', function (evt) {
      if (!root.isConnected) return;
      if (evt.key === 'Escape' && !panel.hidden) closePanel();
    });

    if (slides.length > 1) startRotation();
  }

  function initAll() {
    document.querySelectorAll('[data-toolbar-v2]').forEach(initToolbar);
  }

  // Deferred scripts execute after the document is parsed, so the toolbar DOM
  // exists by now; guard anyway in case this file is ever loaded non-deferred.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: the inline version re-ran when the section HTML was
  // re-injected; the external asset does not, so re-init on section load.
  document.addEventListener('shopify:section:load', function (evt) {
    var scope = evt.target && evt.target.querySelectorAll ? evt.target : document;
    scope.querySelectorAll('[data-toolbar-v2]').forEach(initToolbar);
  });

  window.DFYNE = window.DFYNE || {};
  window.DFYNE.initToolbar = initToolbar;
})();
